import {
  IntegrationsPage,
  IntegrationsProps,
} from "~/pages/integrations/IntegrationsPage";

const IntegrationsEntryPage = ({ scope }: IntegrationsProps) => {
  return <IntegrationsPage scope={scope} />;
};

export default IntegrationsEntryPage;
